const createResponse = (data) => {
  let res = {}
  Object.keys(data).forEach((key) => {
    res[data[key].id] = data[key]
  })
  return res
}

export {
  createResponse
}



// WEBPACK FOOTER //
// ./src/api/response.js